export const MATCH_REEVALUATION_POLL_INTERVAL = 1000
